module.exports = __webpack_public_path__ + "img/W-20.5343d74b.jpg";